import { render, staticRenderFns } from "./daohang.vue?vue&type=template&id=5e0c3f3c&scoped=true&"
import script from "./daohang.vue?vue&type=script&lang=js&"
export * from "./daohang.vue?vue&type=script&lang=js&"
import style0 from "./daohang.vue?vue&type=style&index=0&id=5e0c3f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0c3f3c",
  null
  
)

export default component.exports